module.exports = __webpack_public_path__ + "static/media/creditcard.49e6e03b.svg";